
    
        <title mat-dialog-title>Редактирование модуля</title>
        <button class="mat-raised-button mat-primary" (click)="file_upload()" >Загрузить файл</button><label class="result-label">{{ resultMessage }}</label>
        <mat-form-field [formGroup]="form" appearance="fill">
            <mat-label>Уровень доступа</mat-label>
            <mat-select formControlName="security_level">
                <mat-option *ngFor="let security_level of security_levels" [value]="security_level">{{security_level.ShortTitle}}</mat-option>
            </mat-select>
        </mat-form-field>
        <br>
        <mat-form-field [formGroup]="form" class="example-full-width">
            <mat-label>Краткое описание</mat-label>
            <input class="form-control" minlenght=1 formControlName="short_title" matInput placeholder="Short title" required>
        </mat-form-field>

        <br>

        <mat-form-field [formGroup]="form" class="example-full-width">
            <mat-label>Описание</mat-label>
            <textarea cdkTextareaAutosize formControlName="description" matInput placeholder="Description" required></textarea>
        </mat-form-field>
        <br>

        <mat-form-field [formGroup]="form" class="example-full-width">
            <mat-label>Командная строка</mat-label>
            <input formControlName="commandline" matInput placeholder="CommandLine" required>
        </mat-form-field>
        <br>

        <mat-form-field [formGroup]="form" class="example-full-width">
            <mat-label>Параметры запуска</mat-label>
            <input formControlName="inputparametrs" matInput placeholder="InputParametrs" required>
        </mat-form-field>
        <br>
        

       
       
        <mat-dialog-actions style="justify-content: flex-start;">

            <button class="mat-raised-button mat-warn" (click)="close()">Закрыть</button>
            <button class="mat-raised-button mat-primary" style="margin-left: 5px;" (click)="save()"
                [disabled]="form.get('security_level').value.ID === -1 || form.get('short_title').value.length < 1  ">
                Сохранить
            </button>
        </mat-dialog-actions>
        
        
   


